import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'

import qs from 'qs'

import { SEQUENCE_ENROLL_URL } from 'constants/ResourcesConstants'
import { getGoogleScopes } from 'app/modules/integrations/api'
import { GoogleScopes } from 'app/modules/integrations/constants'

import './style.styl'

import sequenceIconSrc from '!svg-inline!images/svg/sequence.svg'

class EnrollButton extends Component {
  state = {
    modalVisible: false,
    googleScopesFetched: false,
    googleScopes: [],
  }

   componendWillUnmount() {
     window.removeEventListener('message', this.messageEventHandler, false)
   }

   componentWillMount() {
     window.addEventListener('message', this.messageEventHandler, false)
     getGoogleScopes().then(this.receiveScopes)
   }

   messageEventHandler = (event) => {
    const frame = document.getElementById("contact-sequence-enroll-frame")
      if (event.source !== frame && !event.data.type) {
       return
     }
     if (event.data.type ==='@@driftext/hide_enroll_modal' ) {
       this.setState({
         modalVisible: false
       })
     }
   }

  receiveScopes = data => {
    this.setState({
      googleScopes: data,
      googleScopesFetched: true,
    })
  }

  handleButtonClick = () => {
    this.setState({ modalVisible: true })
  }

  handleCloseClick = () => {
    this.setState({
      modalVisible: false,
    })
  }

  render() {
    const { style, emails } = this.props
    const { modalVisible, googleScopesFetched, googleScopes } = this.state

    //will always be 1 email
    const enrollEmail = encodeURIComponent(emails[0])

    const buttonProps = {
      className: 'drift-button',
      style,
      children: [
        <IconSVG src={sequenceIconSrc} key="enroll-button-icon" />,
        <span key="enroll-button-copy">Enroll in Sequence</span>,
      ],
    }
    if (!googleScopesFetched) {
      return <button {...buttonProps} disabled />
    }
    if (!googleScopes.includes(GoogleScopes.READ) || !googleScopes.includes(GoogleScopes.SEND)) {
      return <Link {...buttonProps} to="/settings/email" />
    }
    return (
      <div>
        <button onClick={this.handleButtonClick} {...buttonProps} />
        {modalVisible &&
          <div className="contact-sequence-enroll-wrapper">
             <div className="contact-sequence-enroll">
              <iframe id="contact-sequence-enroll-frame" title="Enroll your sequence" src={`${SEQUENCE_ENROLL_URL}?email=${enrollEmail}`} />
            </div>
          </div>
        }
      </div>
    )
  }
}

export default EnrollButton



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EnrollButton/index.js